import React, { useState } from 'react';
import { Box, Button, Loader } from '@wix/design-system';
import { SingleSelectWidget } from '../../CommonWidgets/SingleSelectWidget/SingleSelectWidget';
import { httpInstallApp } from './httpInstallApp';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
export const InstallAppWidget = _ref => {
  let {
    data,
    context,
    config
  } = _ref;
  const [status, setStatus] = useState('default');
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const onButtonClick = async () => {
    if (status !== 'default') {
      return;
    }
    setStatus('loading');
    try {
      context.onWidgetAction(INSTALL_APP_WIDGET, {
        action: 'click_install_button_CTA'
      }, JSON.stringify(data));
      await httpInstallApp({
        httpClient: context.httpClient,
        appDefId: data.appDefId
      });
      context.send(data.respondText);
    } catch (err) {
      console.error('Custom Widget – InstallAppWidget – onButtonClick ', err);
    } finally {
      setStatus('default');
    }
  };
  const singleSelectWidgetData = {
    options: [{
      title: data.title,
      text: data.description,
      value: data.appDefId
    }],
    badge: {
      text: data.badge
    }
  };
  const buttonLabel = status === 'loading' ? /*#__PURE__*/React.createElement(Loader, {
    size: "tiny"
  }) : data.button;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(SingleSelectWidget, {
    data: singleSelectWidgetData,
    config: config,
    context: context
  }), /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: onButtonClick,
    disabled: areControlsDisabled
  }, buttonLabel)));
};
export const INSTALL_APP_WIDGET = 'INSTALL_APP_WIDGET';
//# sourceMappingURL=InstallAppWidget.js.map